import React, { useEffect, useRef } from 'react'
import companyData from "./tableData.json";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  fetchHolidays,
  initializeHolidaysScreen,
  setDeleteConfirmationPopupVisibility,
  exportHolidays,
  deleteHolidays,
  saveHolidaysTableState,
} from "../../redux/actions/Holidays";
import Holidays from '../../component/Holidays';
import { generatePath } from 'react-router-dom';
import { loadingShow } from '../../services/PostAPI';
import { APP_URLS } from '../../utils/constant';
import { FILTER } from "../../services/common/urlService";
import { DATE_STRATEGY, formatDate } from "../../utils/date";
function HolidaysScreen(props) {
  const {
    fetchHolidays,
    initHolidaysScreen,
    showPageLevelLoader,
    HolidaysListview,
    paginationInfo,
    exportHolidays,
    isHolidaysExportError,
    isHolidaysExportSuccess,
    screenPermissions,
    isLoading,
    deleteHolidays,
    setDeleteConfirmationPopupVisibility,
    isHolidaysDeleteSuccess,
    isHolidaysDeleteError,
    shouldOpenDeleteConfirmationPopup,
    savedTableState,
    saveHolidaysTableState,
  } = props;
  const navigate = useNavigate();

  // Use ref to capture initial savedTableState to avoid closure issues
  const initialSavedState = useRef(savedTableState);

  const buildFetchParamsFromSavedState = (state) => {
    if (!state) return null;
    
    // Helper to check if a string looks like an ISO date
    const isISODateString = (str) => {
      if (typeof str !== 'string') return false;
      return /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(str);
    };
    
    // Helper to format date values to YYYY-MM-DD
    const formatFilterValue = (value) => {
      if (value instanceof Date) {
        return formatDate(value, DATE_STRATEGY.DATE_ISO);
      }
      if (isISODateString(value)) {
        return formatDate(new Date(value), DATE_STRATEGY.DATE_ISO);
      }
      return value;
    };
    
    // Build filter params in the format expected by the API
    const filters = [];
    if (state.filters) {
      Object.keys(state.filters).forEach(key => {
        if (key !== 'global' && state.filters[key]?.value !== null && state.filters[key]?.value !== undefined) {
          const filterValue = state.filters[key].value;
          filters.push({
            filterField: state.filters[key].filterKey || key,
            matchStrategy: state.filters[key].matchStrategy || FILTER.MATCH_STRATEGY.CONTAINS,
            query: formatFilterValue(filterValue)
          });
        }
      });
    }
    
    return {
      sortField: state.sortField || 'id',
      sortOrder: state.sortOrder,
      pageNumber: state.page || 0,
      pageSize: state.rows || 10,
      filters: filters.length > 0 ? filters : undefined,
      userId: localStorage.getItem("userId")
    };
  };

  useEffect(() => {
    initHolidaysScreen();
    
    // Fetch with saved state params if available, otherwise use defaults
    const savedParams = buildFetchParamsFromSavedState(initialSavedState.current);
    
    if (savedParams) {
      fetchHolidays(savedParams);
    } else {
      fetchHolidays({ sortField: 'id', userId: localStorage.getItem("userId") });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadLazyData = (props) => {
    let newPyload = {
      ...props,
      userId: localStorage.getItem("userId")
    }
    fetchHolidays(newPyload);
  };

  const handleTableStateChange = (tableState) => {
    saveHolidaysTableState(tableState);
  };

  const handleCreateHolidays = () => {
    navigate(APP_URLS.HOLIDAYS.CREATE);
  }
  const editHolidaysRoute = (id) => {
    const path = generatePath(APP_URLS.HOLIDAYS.EDIT, {
      id,
    });
    navigate(path);
  };
  const HolidaysData = {
    handleCreateHolidays,
    deleteHolidays,
    isHolidaysDeleteSuccess,
    isHolidaysDeleteError,
    shouldOpenDeleteConfirmationPopup,
    exportHolidays,
    isHolidaysExportError,
    isHolidaysExportSuccess,
    editHolidaysRoute,
    screenPermissions,
    setDeleteConfirmationPopupVisibility,
    fetchHolidayss: loadLazyData,
    tableData: {
      columns: HolidaysListview?.columns,
      rows: HolidaysListview?.rows,
    },
    paginationInfo: {
      pageSize: paginationInfo?.pageSize,
      pageNumber: paginationInfo?.pageNumber,
      totalPages: paginationInfo?.totalPages,
      totalRecords: paginationInfo?.totalRecords,
    },
    isLoading,
    savedTableState,
    onTableStateChange: handleTableStateChange,
  };

  if (showPageLevelLoader) {
    loadingShow("block");
    return null;
  }
  loadingShow("none");
  return (
    <div>
      <Holidays
        {...HolidaysData}
      />
    </div>
  )
}


const mapDispatchToProps = (dispatch) => {
  return {
    initHolidaysScreen: () => dispatch(initializeHolidaysScreen()),
    fetchHolidays: (payload) => dispatch(fetchHolidays(payload)),
    deleteHolidays: (payload) => dispatch(deleteHolidays(payload)),
    exportHolidays: (payload) => dispatch(exportHolidays(payload)),
    setDeleteConfirmationPopupVisibility: (payload) =>
      dispatch(setDeleteConfirmationPopupVisibility(payload)),
    saveHolidaysTableState: (payload) => dispatch(saveHolidaysTableState(payload)),
  };
};


const mapStateToProps = (state, ownProps) => {
  return {

    isHolidaysCreateSuccess: selectFromHolidaysReducer(
      state,
      "isHolidaysCreateSuccess"
    ),
    HolidaysListview: selectFromHolidaysReducer(
      state,
      "HolidaysListview"
    ),
    showPageLevelLoader: selectFromHolidaysReducer(
      state,
      "showPageLevelLoader"
    ),
    paginationInfo: selectFromHolidaysReducer(
      state,
      "paginationInfo"
    ),
    shouldOpenDeleteConfirmationPopup: selectFromHolidaysReducer(
      state,
      "shouldOpenDeleteConfirmationPopup"
    ),
    isPageLevelError: selectFromHolidaysReducer(
      state,
      "isPageLevelError"
    ),
    isFetchingGridData: selectFromHolidaysReducer(
      state,
      "isFetchingGridData"
    ),
    isHolidaysExportError: selectFromHolidaysReducer(
      state,
      "isHolidaysExportError"
    ),
    isHolidaysDeleteSuccess: selectFromHolidaysReducer(
      state,
      "isHolidaysDeleteSuccess"
    ),
    isHolidaysDeleteError: selectFromHolidaysReducer(
      state,
      "isHolidaysDeleteError"
    ),

    isHolidaysExportSuccess: selectFromHolidaysReducer(
      state,
      "isHolidaysExportSuccess"
    ),
    savedTableState: selectFromHolidaysReducer(
      state,
      "savedTableState"
    ),
    ...ownProps,
  };
};

const selectFromHolidaysReducer = (state, path) => {
  return selectHolidaysReducer(state)[path];
};

const selectHolidaysReducer = ({ holidaysReducer }) => {
  return holidaysReducer;
};


export default connect(mapStateToProps, mapDispatchToProps)(HolidaysScreen);
